import React,{ Component, PropTypes } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import ReactSelect from 'react-select'
import { connect } from 'react-redux';
import sectionsLibraryData from '../helpers/SectionsLibraryData';

import SectionItem from './SectionItem';
import MySectionItem from './MySectionItem';

class SectionLibrary extends Component {

    constructor(props){
        super(props);

        this.getMySection = this.getMySection.bind(this)

        this.state = {
            loading: true,
            elements : sectionsLibraryData.getAllSections(),
            options: sectionsLibraryData.options,
            type: 'hero',
        }
    }

    componentWillMount(){
        sectionsLibraryData.on('change', this.getMySection)
    }

    componentDidMount(){
        if(!this.state.elements.length){
            jQuery.ajax({
                type: 'POST',
                url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=pre-section-list',
                dataType: 'json',
                data: {},
                processData: false,
                contentType: false,
                success: function(response) {
                    if(response.status){
                        if (response.data.sections !== undefined) {
                            sectionsLibraryData.setAllSections(response.data.sections)
                            sectionsLibraryData.setAllOptions(response.data.options)
                        }
                    }
                    this.setState({
                        loading: false
                    })
                }.bind(this)
            });
        } else {
            this.setState({
                loading: false
            })
        }
    }

    componentWillUnmount(){
        sectionsLibraryData.removeListener('change', this.getMySection);
    }

    getMySection(){
        this.setState({
            elements: sectionsLibraryData.getAllSections(),
            options: sectionsLibraryData.options,
        })
    }

    getFilteredItems(){
        let newElements = []

        this.state.elements.forEach(element => {
            if (element.type == this.state.type) {
                newElements.push(element);
            }
        });

        return newElements;
    }

    renderSectionTypes(){
        if(!this.state.elements.length){
            return false;
        }
        let types = this.state.elements.map((element, index) => {
        return element.type
        });

        types = this.removeDuplicates(types);

        types = types.map((type, index) => {
        let label = type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())

        let classList = ''

        if (type == this.state.type) {
            classList = 'active'
        }
            return{
                label: label,
                value: type
            }
        })

        return types;
    }
    removeDuplicates(arr){
        let newObj = {}
        arr.forEach(e => {
        newObj[e]=1
        })
        return Object.keys(newObj)
    }

    changeType(e){
        this.setState({
            type: e.value
        });
    }


    render(){
        return(
            <div>
                <div className="sp-pagebuilder-section-lib-panel-container">
                    <div className="sp-pagebuilder-section-lib-panel active" id="sppb-sections-lib">
                        {
                            this.state.elements.length
                            ?
                            <div className="sp-pagebuilder-section-types">

                                <ReactSelect
                                    value={this.state.type}
                                    clearable={false}
                                    options={this.renderSectionTypes()}
                                    onChange={this.changeType.bind(this)}
                                    />

                            </div>
                            :
                            ''
                        }
                        {
                            this.state.elements.length
                            ?
                            <div className="sp-pagebuilder-section-list">
                                <ul>
                                    {
                                    this.getFilteredItems().map((element, index) => {
                                        return(
                                        <SectionItem element={element} key={index} index={index} url={this.state.options.url} pro={true} authorised={this.state.options.authorised} />
                                        )
                                    })
                                    }
                                </ul>
                            </div>
                            :
                            ''
                        }
                        {
                            this.state.loading &&
                            <div className="sppb-sections-loader">
                                <i className="fa fa-circle-o-notch fa-spin"></i>
                                One moment please...
                            </div>
                        }
                        {
                            !this.state.elements.length && !this.state.loading &&
                            <div style={{
                                padding: '10px',
                                textAlign: 'center',
                                background: '#fcf8e3',
                                marginTop: '10px',
                                borderRadius: '3px',
                                color: '#8A6D37'
                            }}>There is no sections found. Please reload and try again.</div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default connect()(SectionLibrary);



// WEBPACK FOOTER //
// ./src/components/SectionLibrary.js